import { FlexColPageContainer } from '../../../components/FlexColPageContainer';
import { Heading } from '../Heading';
import { PhotoAndNoteForm } from './PhotoAndNoteForm';

export const metadata = {
  title: 'Mood Step 4 | Patchooli',
  description: 'Mood Log Entry | Step 4 | Patchooli',
};

export const MoodLogEntryStep4Page = () => {
  return (
    <FlexColPageContainer className="justify-start text-center">
      <Heading className="mb-6">Add a photo or a note (optional).</Heading>
      <PhotoAndNoteForm />
    </FlexColPageContainer>
  );
};
